import React from 'react';
import { useNavigate } from 'react-router-dom';
import SimplizeLogo from '../../components/SimplizeLogo';

export default function UnauthHeader() {
    const navigate = useNavigate();

    return (
        <div className="fixed top-0 left-0 right-0 z-50 bg-white h-14">
            <div className="w-full max-w-5xl mx-auto flex items-center justify-between px-6 sm:px-10 h-full">
                <SimplizeLogo className="h-6 sm:h-7 w-auto" />
                <button
                    onClick={() => navigate('/login')}
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-gray-900 text-white hover:bg-gray-800 transition-colors"
                >
                    Bắt đầu trải nghiệm
                </button>
            </div>
        </div>
    );
}
